module.exports = __webpack_public_path__ + "media/img/why-vendor/banner-main-a8e939a74c04f5d5a4cd9462c99b75a6.png";